"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element if `variant="text"` and `color="cta"`. */
    textCta: {
      color: theme.palette.orange.light,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.orange.light, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="cta"`. */
    outlinedCta: {
      color: function color(props) {
        return props.highContrast ? theme.palette.orange.contrastText : theme.palette.orange.light;
      },
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.orange.light, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.orange.light),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.orange.light, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="cta"`. */
    containedCta: {
      color: theme.palette.orange.lightText,
      backgroundColor: theme.palette.orange.light,
      '&:hover': {
        backgroundColor: theme.palette.orange.main
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="warning"`. */
    textWarning: {
      color: theme.palette.warning.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.warning.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: function color(props) {
        return props.highContrast ? theme.palette.warning.contrastText : theme.palette.warning.main;
      },
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.warning.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.warning.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.warning.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="warning"`. */
    containedWarning: {
      color: theme.palette.warning.contrastText,
      backgroundColor: theme.palette.warning.main,
      '&:hover': {
        backgroundColor: theme.palette.warning.dark
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="error"`. */
    textError: {
      color: theme.palette.error.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: function color(props) {
        return props.highContrast ? theme.palette.error.contrastText : theme.palette.error.main;
      },
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.error.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.error.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="error"`. */
    containedError: {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="transparent"`. */
    textTransparent: {
      color: theme.palette.white.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.white.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="transparent"`. */
    outlinedTransparent: {
      color: function color(props) {
        return props.highContrast ? theme.palette.white.contrastText : theme.palette.white.main;
      },
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.white.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.white.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.white.main, theme.palette.action.hoverOpacity)
      }
    },
    sizeExtraLarge: {
      padding: '0px 28px',
      minHeight: 64,
      fontSize: '17px',
      fontWeight: 700
    }
  };
};

var CustomButton = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CustomButton, _PureComponent);

  var _super = _createSuper(CustomButton);

  function CustomButton() {
    (0, _classCallCheck2["default"])(this, CustomButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CustomButton, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          classes = _this$props.classes,
          variant = _this$props.variant,
          color = _this$props.color,
          size = _this$props.size;

      if (variant === 'contained' && color === 'transparent') {
        variant = 'outlined';
      }

      var className = (0, _classnames["default"])(this.props.className, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, classes.textWarning, variant === 'text' && color === 'warning'), (0, _defineProperty2["default"])(_classNames, classes.outlinedWarning, variant === 'outlined' && color === 'warning'), (0, _defineProperty2["default"])(_classNames, classes.containedWarning, variant === 'contained' && color === 'warning'), (0, _defineProperty2["default"])(_classNames, classes.textError, variant === 'text' && color === 'error'), (0, _defineProperty2["default"])(_classNames, classes.outlinedError, variant === 'outlined' && color === 'error'), (0, _defineProperty2["default"])(_classNames, classes.containedError, variant === 'contained' && color === 'error'), (0, _defineProperty2["default"])(_classNames, classes.textCta, variant === 'text' && color === 'cta'), (0, _defineProperty2["default"])(_classNames, classes.outlinedCta, variant === 'outlined' && color === 'cta'), (0, _defineProperty2["default"])(_classNames, classes.containedCta, variant === 'contained' && color === 'cta'), (0, _defineProperty2["default"])(_classNames, classes.textTransparent, variant === 'text' && color === 'transparent'), (0, _defineProperty2["default"])(_classNames, classes.outlinedTransparent, variant === 'outlined' && color === 'transparent'), (0, _defineProperty2["default"])(_classNames, classes.sizeExtraLarge, size === 'xl'), _classNames));
      var muiColor = color;

      if (color === 'transparent' || color === 'warning' || color === 'error' || color === 'cta') {
        muiColor = undefined;
      }

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
        variant: variant,
        color: muiColor,
        className: className,
        classes: _objectSpread({}, (0, _omit["default"])(classes, 'textWarning', 'outlinedWarning', 'containedWarning', 'textError', 'outlinedError', 'containedError', 'textTransparent', 'outlinedTransparent', 'textCta', 'outlinedCta', 'containedCta', 'sizeExtraLarge'))
      }, (0, _omit["default"])(this.props, 'variant', 'color', 'classes', 'className', 'dataElementLocation', 'dataElementLabel', 'dataElementId', 'highContrast')), this.props.children);
    }
  }]);
  return CustomButton;
}(_react.PureComponent);

CustomButton.propTypes = {
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object,
  color: _propTypes["default"].oneOf(['default', 'primary', 'secondary', // our custom
  'warning', 'error', 'transparent', 'cta']),
  disabled: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['text', 'outlined', 'contained']),
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xl']),
  highContrast: _propTypes["default"].bool
};
CustomButton.defaultProps = {
  color: 'primary',
  variant: 'contained',
  highContrast: false
};
var CustomButtonStyled = (0, _styles.withStyles)(styles)(CustomButton);
CustomButtonStyled.displayName = 'Button';

var _default = (0, _taggingHelper.withDataProperty)(CustomButtonStyled, _taggingHelper.DataElementTypes.BUTTON);

exports["default"] = _default;